export default __webpack_public_path__ + "static/media/weathersvlogo.5dcdb070.png";